import { Box, Typography } from '@mui/material';
import classes from './TitleContainer.module.scss';
const TitleContainer = ({
  title,
  description
}: {
  title: string;
  description: string;
}) => {
  return <Box className={classes['title-container']} data-sentry-element="Box" data-sentry-component="TitleContainer" data-sentry-source-file="TitleContainer.tsx">
			<Typography variant="titleContainer" className={classes['title-text']} data-sentry-element="Typography" data-sentry-source-file="TitleContainer.tsx">
				{title}
			</Typography>
			<Typography variant="titleDescription" className={classes['title-description']} data-sentry-element="Typography" data-sentry-source-file="TitleContainer.tsx">
				{description}
			</Typography>
		</Box>;
};
export default TitleContainer;